
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';

    @Component({
        computed: {
            ...mapState('patient', ['loaders', 'druckvorgangRuecksetzung']),
        },
        methods: {
            ...mapActions('patient', ['rechnungAbschliessen']),
        },
    })
    export default class DialogDruckOk extends Vue {
        @Prop() visible!: boolean;
    }
